import { createFileRoute } from '@tanstack/react-router'
import { receiptSearchSchema, ReceiptWorkspace } from '@/features/bill/index.ts'

export const Route = createFileRoute('/_authenticated/finance/receipts')({
  validateSearch: receiptSearchSchema,
  component: ReceiptPage,
  head: () => ({ meta: [{ title: '收款通知单工作台 · Super Mega' }] })
})
function ReceiptPage() {
  const { currentSession } = Route.useRouteContext()
  const canManage =
    currentSession.isSuperAdmin ||
    currentSession.permissions.some((permission) => permission.startsWith('bill.') && !permission.endsWith('.read'))
  const { ids, revisionNumber } = Route.useSearch()
  return (
    <ReceiptWorkspace
      key={`${ids.join(':')}:${revisionNumber ?? 'current'}`}
      canManage={canManage}
      ids={ids}
      revisionNumber={revisionNumber}
    />
  )
}
